<template>
  <ul>
    <v-tree
      ref="tree"
      :data="treeData"
      v-if="treeData.length"
      :radio="true"
      :selectAlone="true"
      @node-check="nodeChecked"
      :draggable="false"
      :halfcheck="true"
      :tpl="tpl"
    />
  </ul>
</template>

<script>
import { VTree } from "vue-tree-halower";
import JSONDATA from "../../configs/tree.json";
export default {
  name: "HierarchicalMenuList",
  data: () => {
    return {
      itemSelected: null,
      treeItems: [],
      JSONDATA: JSONDATA,
      treeData: []
    };
  },
  components: {
    VTree: VTree
  },
  props: {
    items: {
      required: true,
      type: Array
    },
    refine: {
      required: true,
      type: Function
    },
    createURL: {
      required: true,
      type: Function
    }
  },
  mounted() {
    let o = {};
    let _this = this;
    this.JSONDATA.forEach(function(a) {
      a.children = o[a.id] && o[a.id].children;
      o[a.id] = a;
      if (a.parentID === null) {
        _this.treeData.push(a);
      } else {
        o[a.parentID] = o[a.parentID] || {};
        o[a.parentID].children = o[a.parentID].children || [];
        o[a.parentID].children.push(a);
      }
    });
  },
  computed: {},
  methods: {
    tpl(...args) {
      let { 0: node} = args;
      let titleClass = node.selected ? "fill-current" : "";
      return (
        <span>
          <feather-icon
            icon="CircleIcon"
            style="vertical-align: bottom;"
            svgClasses={"text-primary " + titleClass}
            onClick={() => {
              this.$refs.tree.nodeSelected(node);
              if (node.selected) {
                if(node.parentID == null){
                  this.refine("");
                }
                this.refine(node.value);
              } else {
                this.refine("");
              }
            }}
          />
          <span
            class={titleClass}
            domPropsInnerHTML={node.title}
            onClick={() => {
              this.$refs.tree.nodeSelected(node);
              if (node.selected) {
                if(node.parentID == null){
                  this.refine("");
                }
                this.refine(node.value);
              } else {
                this.refine("");
              }
            }}
          ></span>
        </span>
      );
    },
    async loadChild(node) {
      if (this.itemSelected !== null && node.expanded) {
        this.itemSelected = null;
      } else {
        this.itemSelected = node;
      }
      const { checked = false } = node;
      if (checked) {
        this.$refs.tree.childCheckedHandle(node, checked);
      }
      this.refine(node.value);
    },
    nodeChecked(node) {
      if (this.itemSelected !== null && node.expanded) {
        this.itemSelected = null;
      } else {
        this.itemSelected = node;
      }
      const { checked = false } = node;
      this.$refs.tree.childCheckedHandle(node, checked);
      this.refine(node.value);
    }
  }
};
</script>
<style lang="scss">
.halo-tree .inputCheck {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  border: 1.5px solid #565656;
  top: 4px;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  border-radius: 16px;
}
.box-checked {
  width: 16px;
  height: 16px;
  border: 1.5px solid #214c5f !important;
}
.halo-tree .check {
  border-radius: 16px;
}
.halo-tree .inputCheck.box-checked::after,
.halo-tree .box-halfchecked::after {
  content: "";
  display: block;
  z-index: 1;
  width: 100%;
  position: relative;
  text-align: center;
  height: 14px;
  width: 14px;
  background-color: #214c5f;
  border-radius: 50%;
  display: inline-block;
}
.halo-tree .box-halfchecked {
  background-color: "#fff";
}
.text-primary {
  color: #214c5f !important;
}
</style>
